var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerificationSideIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85002 0V1.92299H2.00321C1.98183 1.92299 1.96133 1.93234 1.94621 1.94897C1.9311 1.96559 1.92261 1.98814 1.92261 2.01165V8.32617H0.177246C0.177246 6.20769 0.177246 4.08922 0.177246 1.97073C0.177246 1.44806 0.366034 0.946802 0.702074 0.577218C1.03811 0.207633 1.49388 0 1.96911 0H7.85002Z",
    fill: "#535C64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.17 0H14.627V1.92299H20.17C20.1916 1.92298 20.2125 1.93221 20.2281 1.94875C20.2437 1.96528 20.2529 1.98783 20.2537 2.01165V8.32617H21.9959V2.01165C21.9959 1.47871 21.8036 0.967561 21.4613 0.590401C21.1189 0.213242 20.6545 0.000903275 20.17 0Z",
    fill: "#535C64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92261 21.9919V15.7762H0.177246V21.9919C0.177246 22.5245 0.36962 23.0353 0.712055 23.4119C1.05449 23.7886 1.51893 24.0001 2.00321 24.0001H7.85002V22.0806H2.00321C1.98183 22.0806 1.96133 22.0712 1.94621 22.0546C1.9311 22.038 1.92261 22.0154 1.92261 21.9919Z",
    fill: "#535C64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.17 22.0804H14.627V24H20.17V22.0804Z",
    fill: "#535C64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9988 15.7762V21.9919C22.0004 22.0214 22.0004 22.051 21.9988 22.0806H20.1729C20.1837 22.081 20.1945 22.0791 20.2046 22.0748C20.2148 22.0706 20.224 22.0641 20.2319 22.0558C20.2397 22.0475 20.2459 22.0376 20.2501 22.0266C20.2544 22.0157 20.2566 22.0038 20.2566 21.9919V15.7762H21.9988Z",
    fill: "#535C64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8833 7.75348H10.293V13.2259H11.8833V7.75348Z",
    fill: "#535C64"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8833 15.1387H10.293V16.9219H11.8833V15.1387Z",
    fill: "#535C64"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81904 7.75348H6.22559V9.66966H7.81904V7.75348Z",
    fill: "#535C64"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2929 13.2258H8.69946V15.1386H10.2929V13.2258Z",
    fill: "#535C64"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7089 7.75348H14.1155V9.66966H15.7089V7.75348Z",
    fill: "#535C64"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationSideIcon);
export default __webpack_public_path__ + "static/media/verification-side-icon.bc6227ea5497654d2a0f42e40f36ffae.svg";
export { ForwardRef as ReactComponent };